/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import IconPicker, { renderIcon } from './IconPicker';
import ImageUpload from './ImageUpload';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  IconPicker,
  ImageUpload,
  Question,
  renderIcon,
  SelectLang,
};
